import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const teamMembers = [
  {
    name: '李晓婷',
    title: '创始人 & 首席情感咨询师',
    intro: '国家二级心理咨询师，拥有15年情感咨询经验。曾服务于多家知名心理咨询机构，帮助超过2000对伴侣改善关系。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20warm%20lighting%2C%20friendly%20confident%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20look%2C%20editorial%20portrait%20photography&width=400&height=400&seq=team-lx-01&orientation=squarish',
  },
  {
    name: '王明辉',
    title: '联合创始人 & 两性关系专家',
    intro: '心理学博士，专注于伴侣沟通与亲密关系研究。多所高校客座讲师，著有《沟通的艺术：伴侣篇》等畅销书籍。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20confident%20expression%2C%20simple%20cream%20background%2C%20editorial%20portrait%20photography&width=400&height=400&seq=team-wm-02&orientation=squarish',
  },
  {
    name: '张明华',
    title: '医学顾问 & 性健康专家',
    intro: '医学博士，三甲医院妇科主任医师。长期致力于推广科学的性健康教育，在医学界享有盛誉。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20doctor%20portrait%2C%20warm%20smile%2C%20simple%20cream%20background%2C%20professional%20medical%20portrait%20photography&width=400&height=400&seq=team-zm-03&orientation=squarish',
  },
  {
    name: '陈文静',
    title: '资深心理咨询师',
    intro: '心理学硕士，擅长认知行为治疗和情绪聚焦疗法。专注于帮助个人在情感中实现自我成长。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20warm%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=team-cw-04&orientation=squarish',
  },
];

const testimonials = [
  {
    name: '小雅',
    text: '在爱爱网上学到了很多关于伴侣沟通的技巧。现在我和老公的争吵明显减少了，关系比以前更加亲密。真的很感谢这个平台！',
    role: '已注册2年',
  },
  {
    name: '浩然',
    text: '坦白说，以前我对两性健康知识处于一知半解的状态。爱爱网的文章让我从科学角度了解了很多之前困惑的问题，受益匪浅。',
    role: '已注册1年',
  },
  {
    name: '静怡',
    text: '失恋后一度很崩溃，朋友推荐了爱爱网。读了那些关于自我成长和情绪恢复的文章，真的给了我很大的力量。现在我已经完全走出来了。',
    role: '已注册半年',
  },
  {
    name: '志远',
    text: '和女友异地恋两年了，爱爱网上的异地恋指南帮了我们很多。那些实用的建议真的很管用，我们已经计划明年结婚了。',
    role: '已注册1年半',
  },
  {
    name: '美玲',
    text: '作为两个孩子的妈妈，在亲密关系上确实遇到了很多挑战。爱爱网的内容给了我很多启发，让我重新思考了婚姻中的角色和边界。',
    role: '已注册3年',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    formData.delete('website_alt');

    const textarea = formData.get('message') as string;
    if (textarea && textarea.length > 500) {
      setFormError('留言内容不能超过500个字符');
      setFormStatus('error');
      return;
    }

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const response = await fetch('https://readdy.ai/api/form/d9pmutmb4qjhggaeq1e0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not json
      }

      const code = parsed?.code || '';
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const errMsg = serverMsg || responseText || '提交失败，请稍后再试';
        setFormError(errMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱爱网',
    url: 'https://aiaiwang.com',
    description: '爱爱网是专注成人情感与亲密关系的交流平台，提供情感咨询、两性健康知识、伴侣沟通技巧等优质内容。',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <SEOHead
        title="关于我们"
        description="爱爱网专注成人情感与亲密关系，由资深心理咨询师和两性关系专家共同创办。了解我们的品牌故事、专业团队和用户口碑。"
        keywords="爱爱网关于我们,情感平台介绍,两性专家团队,用户口碑"
      />
      <Navbar />
      <main className="pt-20 pb-14 min-h-screen bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />

          {/* Brand Introduction */}
          <section className="mt-8 mb-16">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              关于爱爱网
            </h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <div className="relative h-[350px] md:h-[450px] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20cozy%20modern%20office%20space%20with%20soft%20natural%20lighting%2C%20comfortable%20sofa%20and%20wooden%20furniture%2C%20plants%20in%20corners%2C%20cream%20and%20warm%20beige%20interior%2C%20peaceful%20professional%20atmosphere%2C%20editorial%20photography&width=900&height=700&seq=about-brand-01&orientation=landscape"
                    alt="爱爱网办公环境"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌故事
                </h2>
                <div className="flex flex-col gap-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    爱爱网创立于2018年，源于创始团队对国内成人情感教育领域现状的深刻洞察。我们发现，虽然人们对亲密关系的关注度日益提升，但市场上却缺乏一个既专业又温暖的平台来提供科学、健康的指导。
                  </p>
                  <p>
                    我们汇聚了心理咨询师、医学专家、两性关系研究者等多元背景的专业人士，致力于打造一个让成年人可以安心学习、坦诚交流的情感知识社区。
                  </p>
                  <p>
                    经过数年的发展，爱爱网已成为国内最具影响力的成人情感交流平台之一，累计服务超过50万用户，发布原创专业文章2000余篇。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Team */}
          <section id="team" className="mb-16">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                专家团队
              </h2>
              <p className="text-sm md:text-base text-foreground-500">汇聚行业顶尖人才，为您提供专业指导</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {teamMembers.map((member) => (
                <div key={member.name} className="bg-background-50 rounded-xl border border-background-200/60 p-6 text-center">
                  <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-1">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mb-3">{member.title}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">{member.intro}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Testimonials */}
          <section id="testimonials" className="mb-16 py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                  用户口碑
                </h2>
                <p className="text-sm md:text-base text-foreground-500">来自真实用户的温暖反馈</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.slice(0, 3).map((t, i) => (
                  <div key={i} className="bg-background-50 rounded-xl border border-background-200/60 p-6">
                    <div className="flex items-center gap-2 mb-4">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.text}</p>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-xs font-semibold text-primary-600">{t.name[0]}</span>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                        <div className="text-xs text-foreground-400">{t.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
                {testimonials.slice(3, 5).map((t, i) => (
                  <div key={i} className="bg-background-50 rounded-xl border border-background-200/60 p-6">
                    <div className="flex items-center gap-2 mb-4">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.text}</p>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-xs font-semibold text-primary-600">{t.name[0]}</span>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                        <div className="text-xs text-foreground-400">{t.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="mb-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  联系我们
                </h2>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们的团队会在1-2个工作日内回复。
                </p>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮件</h4>
                      <p className="text-sm text-foreground-500">contact@aiaiwang.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h4>
                      <p className="text-sm text-foreground-500">搜索"爱爱网"关注我们</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-secondary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h4>
                      <p className="text-sm text-foreground-500">400-XXX-XXXX（工作日 9:00-18:00）</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8">
                  <h3 className="text-lg font-semibold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                    发送消息
                  </h3>

                  {formStatus === 'success' ? (
                    <div className="text-center py-10">
                      <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                        <i className="ri-check-line text-accent-600 text-2xl"></i>
                      </div>
                      <h4 className="text-base font-semibold text-foreground-950 mb-2">消息已发送</h4>
                      <p className="text-sm text-foreground-500">感谢您的留言，我们会在1-2个工作日内回复您。</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="true">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="contact_name" className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
                          <input
                            type="text"
                            id="contact_name"
                            name="name"
                            required
                            className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                            placeholder="请输入您的姓名"
                          />
                        </div>
                        <div>
                          <label htmlFor="contact_email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                          <input
                            type="email"
                            id="contact_email"
                            name="email"
                            required
                            className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                            placeholder="请输入您的邮箱"
                          />
                        </div>
                      </div>
                      <div>
                        <label htmlFor="contact_subject" className="block text-xs font-medium text-foreground-700 mb-1.5">主题</label>
                        <input
                          type="text"
                          id="contact_subject"
                          name="subject"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入消息主题"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact_message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                        <textarea
                          id="contact_message"
                          name="message"
                          rows={4}
                          required
                          maxLength={500}
                          className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-white text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                          placeholder="请输入您的留言（500字以内）"
                        ></textarea>
                      </div>

                      <div className="honeypot-field" aria-hidden="true">
                        <label htmlFor="contact_website_alt">Website</label>
                        <input
                          type="text"
                          id="contact_website_alt"
                          name="website_alt"
                          tabIndex={-1}
                          autoComplete="off"
                          aria-hidden="true"
                          readOnly
                        />
                      </div>

                      {formStatus === 'error' && formError && (
                        <div className="px-4 py-3 rounded-lg bg-red-50 text-red-600 text-xs border border-red-100">
                          {formError}
                        </div>
                      )}

                      <button
                        type="submit"
                        className="px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        发送消息
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}